<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            v-if="loaded"
            :items="users"
            :fields="fields">
            <template v-slot:options>
                <b-button
                    class="btn-admin-users"
                    v-b-modal="'add-admin-account'"
                    variant="primary">
                    <i class="fas fa-plus fa-fw"></i> {{ $t('admin.add_admin') }}
                </b-button>

                <design-2021-admin-accounts-index-add-account-modal-component></design-2021-admin-accounts-index-add-account-modal-component>
            </template>

            <template v-slot:cell(actions)="data">
                <div class="actions">
                    <b-button
                        class="btn-settings btn-settings-accounts"
                        v-b-modal="'admin-accounts-update-user-modal' + data.item.id"
                        variant="primary-icon-only"
                        :v-b-tooltip="$t('common.modify')"></b-button>

                    <design-2021-admin-accounts-index-update-account-modal-component
                        :user="data.item"></design-2021-admin-accounts-index-update-account-modal-component>

                    <b-button
                        class="btn-remove btn-remove-accounts"
                        v-b-tooltip="$t('common.delete')"
                        variant="danger-icon-only"
                        @click="onRemove(data.item)"></b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
import { ords } from '../../../app';

export default {
    name: 'design-2021-admin-accounts-index-component',
    props: ['usersIn', 'schoolsIn'],
    data() {
        return {
            users: [],
            loaded: false,
            fields: [
                {
                    key: 'full_name',
                    label: this.$t('common.name'),
                    sortable: true,
                },
                {
                    key: 'email',
                    label: 'E-mail',
                    sortable: true,
                },
                {
                    key: 'userable_id',
                    label: 'School',
                },
                {
                    key: 'type_name',
                    label: 'Type',
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    methods: {
        onRemove(user) {
            this.alert
                .confirm(
                    this.$t('common.delete'),
                    this.$t('admin.are_you_sure_you_want_to_delete_this_account'),
                    this.$t('common.delete'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.delete(this.routes.adminAccountDelete(user.id)).then(
                            (response) => {
                                user.remove();

                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
    },
    mounted() {
        if (!this.loaded) {
            ords.use('user').add(this.usersIn);

            ords.use('user')
                .where('type', '=', 'admin')
                .get()
                .subscribe((user) => {
                    this.users = user;
                });

            this.loaded = true;
        }
    },
};
</script>

<style scoped lang="scss">
.actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .btn {
        font-size: 1.125rem;
    }

    .btn-edit-roadmap:before {
        margin-right: 0;
    }
}
</style>
